import { InjectionToken } from '@angular/core';
import { DimensionLevelService } from './dimension-level.service';

export const ALWAYS_TOP_DIMENSION_LEVEL_SERVICE = new InjectionToken<DimensionLevelService>('ALWAYS_TOP_DIMENSION_LEVEL_SERVICE');
export const CHECK_NEXT_DIMENSION_LEVEL_SERVICE = new InjectionToken<DimensionLevelService>('CHECK_NEXT_DIMENSION_LEVEL_SERVICE');
